// Shopify product IDs that should NOT be shown on this site.
// Use the number from the product's URL in Shopify admin (e.g. 9037948911861).
//
// Products listed here are removed from every grid and their product page 404s.
// To release them: remove the IDs on a review branch, check the deploy preview,
// then merge that branch into main.
const HIDDEN_PRODUCT_IDS = [
  15472413606133,
  15472425468149,
  15472439197941,
  15472455713013,
  15472489201909,
  15472506568949,
];

const hiddenIds = new Set(HIDDEN_PRODUCT_IDS.map(String));

// Storefront IDs look like "gid://shopify/Product/9037948911861"
export const isProductHidden = (product) =>
  hiddenIds.has(String(product?.id).split('/').pop());
